/** Smooth-scroll `el` to the vertical centre of its scroll `container`. Shared by
 * the trail and Agent Steps panes to keep the active row/step in view. */
export function scrollToVerticalCenter(
  container: HTMLElement,
  el: HTMLElement,
): void {
  const containerRect = container.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();
  const offset =
    elRect.top -
    containerRect.top +
    elRect.height / 2 -
    container.clientHeight / 2;
  container.scrollBy({ top: offset, behavior: "smooth" });
}
